export const translations = {
  fr: {
    p2pExtra: {
      channelClosed: 'Trading Direct temporairement fermé', operatorInfo: "Information de l'opérateur",
      companyCounterparty: 'Contrepartie : alphaswapp — vous êtes Taker', p2pCounterparty: 'P2P — échange entre clients',
      delayWarning: "Le traitement peut nécessiter jusqu'à 24 heures supplémentaires en cas de vérification renforcée, de contrôle d'intégrité du paiement ou d'imprévu lié aux parties. Merci de votre patience.",
      sendCryptoAdmin: "Envoyez la crypto à l'adresse communiquée par l'opérateur :",
      payToCardAdmin: "Envoyez le paiement à la carte communiquée par l'opérateur, puis envoyez le reçu :",
      waitingCardInfo: "L'opérateur va vous communiquer les coordonnées de paiement ici. Vous pouvez aussi le contacter via le chat support.",
      waitingEscrow: 'En attente du séquestre crypto du vendeur...',
      grossAmount: 'Montant brut', commission7: 'Commission 7%', youReceive: 'Vous recevrez',
      buyerWillGet: "Transmis à l'acheteur", buyerGets: "L'acheteur reçoit", chooseBank: 'Votre banque',
      cancelBtn: 'Annuler',
      autoPrice: 'Prix unitaire — cours du marché (automatique)', liveRate: 'Temps réel',
      sellerEscrowPending: "Crypto déclarée envoyée — l'opérateur vérifie la réception du séquestre.",
      sellerEscrowReceived: "Séquestre confirmé ✓ — en attente du paiement de l'acheteur.",
      sellerFiatSent: "L'acheteur a déclaré le paiement — l'opérateur vérifie le reçu avant de finaliser.",
    },
    support: {
      title: 'Support alphaswapp', online: 'En ligne — réponse rapide',
      empty: 'Une question sur votre transaction ? Écrivez-nous, notre équipe vous répond ici.',
      placeholder: 'Votre message...', tooBig: 'Fichier trop volumineux (max 10 Mo)',
      telegram: 'Ou écrivez-nous sur Telegram : @alphaswapp',
    },
    fiatlive: { title: 'Taux fiat en direct' },
    alerts: {
      navLabel: 'Alertes', badge: 'Temps réel', title: 'Alertes de prix',
      subtitle: "Recevez une notification dès que le prix atteint votre seuil, même si l'onglet est fermé.",
      enableNotifs: 'Activer les notifications', disableNotifs: 'Désactiver les notifications',
      notifsEnabled: 'Notifications activées !', notifsDisabled: 'Notifications désactivées',
      notifsBlocked: 'Notifications bloquées par le navigateur. Autorisez-les dans les paramètres du site.',
      notSupported: 'Navigateur non compatible', createTitle: 'Nouvelle alerte', crypto: 'Crypto',
      condition: 'Condition', above: 'Au-dessus de', below: 'En dessous de', targetPrice: 'Prix cible',
      currentPrice: 'Prix actuel', create: "Créer l'alerte", creating: 'Création...',
      created: 'Alerte créée !', deleted: 'Alerte supprimée', invalidPrice: 'Prix cible invalide',
      error: 'Une erreur est survenue', activeTitle: 'Alertes actives',
      noActive: 'Aucune alerte active. Créez-en une pour être notifié.',
      triggeredTitle: 'Alertes déclenchées', triggeredAt: 'Déclenchée à',
      enableHint: 'Activez les notifications pour être alerté même en arrière-plan',
      manage: 'Gérer', noActiveShort: 'Aucune alerte active.', createOne: 'Créer une alerte',
    },
    p2p: {
      badge: 'Nouveau',
      title: 'Trading Direct',
      subtitle: 'Achetez et vendez en direct avec d\'autres utilisateurs. Vos fonds sont sécurisés sous séquestre par alphaswapp jusqu\'à la fin de la transaction.',
      buy: 'Acheter',
      sell: 'Vendre',
      orderbook: 'Carnet d\'ordres',
      myOrders: 'Mes ordres',
      createOrder: 'Créer un ordre',
      amount: 'Montant',
      price: 'Prix unitaire',
      total: 'Total',
      commission: 'Commission vendeur 7%',
      noOrders: 'Aucun ordre disponible. Créez le vôtre !',
      takeOrder: 'Prendre cet ordre',
      waiting: 'En attente d\'une contrepartie',
      matched: 'Contrepartie trouvée',
      escrowPending: 'Crypto en cours de vérification',
      escrowReceived: 'Crypto sous séquestre',
      fiatSent: 'Paiement envoyé',
      completed: 'Terminé',
      cancelled: 'Annulé',
      sendCrypto: 'Envoyez la crypto au wallet alphaswapp',
      uploadReceipt: 'Envoyer le reçu bancaire',
      iSent: 'J\'ai envoyé la crypto',
      bankCard: 'Carte bancaire',
      bankName: 'Banque',
      walletAddr: 'Adresse de votre wallet',
      network: 'Réseau',
      escrowInfo: 'Fonds bloqués maximum 45 minutes',
      howTitle: 'Comment ça marche ?',
      how1: 'Le vendeur envoie sa crypto au wallet sécurisé alphaswapp',
      how2: 'L\'acheteur envoie le paiement bancaire directement au vendeur',
      how3: 'Après vérification du reçu, la crypto est libérée à l\'acheteur',
      presentTitle: 'Tradez en direct, entre vous',
      presentDesc: 'Un carnet d\'ordres peer-to-peer avec séquestre sécurisé : vos ordres restent en ligne jusqu\'à trouver une contrepartie.',
      cta: 'Découvrir le Trading Direct',
    },
    common: {
      quickCalc: 'Calculez votre échange en direct',
      authSubtitle: 'Accédez à votre compte alphaswapp',
      dashboard: 'Tableau de bord',
      logout: 'Déconnexion',
      level: 'Niveau',
      high: 'Plus haut',
      low: 'Plus bas',
      variation: 'Variation',
      price: 'Prix',
      transferSuccess: 'Votre demande de transfert a été envoyée !',
      invalidAmount: 'Montant invalide',
      nameRequired: 'Nom requis',
      phoneRequired: 'Téléphone requis',
      invalidEmail: 'Email invalide',
      start: 'Commencer',
      continueGoogle: 'Continuer avec Google',
      loading: 'Chargement...',
      processing: 'Traitement...',
      home: 'Accueil',
      rateLocked: 'Taux bloqué',
      rateLockInfo: 'Taux garanti pendant 10 minutes',
      lockExpired: 'Le taux a expiré, actualisation...',
      kycRequired: 'Vérification d\'identité requise',
      kycRequiredDesc: 'Complétez votre KYC pour augmenter vos limites d\'échange',
      secure: 'Sécurisé',
      fast: 'Rapide',
      recentExchanges: 'Derniers échanges',
      sent: 'Envoyé',
      received: 'Reçu',
      date: 'Date',
      direction: 'Direction',
      commission: 'Commission',
      exchangeTime: 'Temps d\'échange',
      supportAvailable: 'Support disponible',
      liveRates: 'Prix en temps réel',
    },
    nav: {
      exchange: "Échange",
      cards: "Cartes",
      business: "Business",
      privacy: "Confidentialité",
      login: "Se connecter",
      logout: "Déconnexion",
      dashboard: "Dashboard",
      sendMoney: "Envoi d'argent",
      admin: "Admin",
      home: "Accueil"
    },
    hero: {
      calcDesc: 'Taux actualisés toutes les 30 secondes. Bloquez votre prix pendant 10 minutes au moment de la transaction.',
      rateLock: 'Taux bloqué 10 min',
      darkTitle: 'Une commission unique. Zéro surprise.',
      darkDesc: '7% tout compris sur chaque opération — achat, vente, envoi. Pas de frais cachés, pas de mauvaise surprise à l\'arrivée.',
      commissionTitle: '7% tout compris',
      commissionDesc: 'Une seule commission transparente sur chaque opération. Affichée avant de valider.',

      badge: "Échange crypto ultra-rapide",
      title: "Échangez vos cryptos en toute",
      titleHighlight: "sécurité",
      description: "La plateforme d'échange la plus rapide et sécurisée. Support de 20+ cryptomonnaies avec les meilleurs taux du marché.",
      startBtn: "Commencer maintenant",
      apiBtn: "API Développeur"
    },
    exchangeWidget: {
      title: "Convertisseur Rapide",
      youSend: "Vous envoyez",
      youReceive: "Vous recevez",
      youGive: "Vous donnez",
      rate: "Taux de change",
      fees: "Frais",
      exchange: "Échanger maintenant",
      buy: "Acheter",
      sell: "Vendre",
      selectCrypto: "Sélectionner crypto",
      selectPayment: "Sélectionner paiement",
      enterAmount: "Entrez le montant",
      accountInfo: "Informations du compte",
      email: "Email",
      continue: "Continuer",
      confirm: "Confirmer l'échange"
    },
    features: {
      title: "Pourquoi choisir alphaswapp ?",
      speed: {
        title: "Échanges instantanés",
        description: "Recevez vos fonds en quelques minutes grâce à notre système automatisé"
      },
      security: {
        title: "100% Sécurisé",
        description: "Vos transactions sont protégées par des protocoles de sécurité avancés"
      },
      support: {
        title: "Support 24/7",
        description: "Notre équipe est disponible pour vous aider à tout moment"
      }
    },
    recentExchanges: {
      title: "Derniers échanges",
      ago: "Il y a"
    },
    reviews: {
      title: "Derniers avis"
    },
    services: {
      exchange: "Échange",
      qrPayment: "Paiement QR",
      mobileMoney: "Cartes prépayées",
      bankTransfer: "Virement",
      cards: "Cartes",
      wallet: "Portefeuille",
      send: "Envoyer",
      cashback: "Cashback"
    },
    auth: {
      login: "Connexion",
      register: "Inscription",
      email: "Email",
      password: "Mot de passe",
      phone: "Téléphone",
      loginBtn: "Se connecter",
      registerBtn: "S'inscrire",
      googleBtn: "Continuer avec Google",
      or: "ou",
      noAccount: "Pas encore de compte ?",
      hasAccount: "Déjà un compte ?",
      terms: "En vous connectant, vous acceptez nos",
      termsLink: "Conditions d'utilisation",
      privacyLink: "Politique de confidentialité"
    },
    dashboard: {
      welcome: "Bonjour",
      overview: "Voici un aperçu de votre compte",
      totalValue: "Valeur totale",
      totalVolume: "Volume total",
      vipLevel: "Niveau VIP",
      cashbackEarned: "Cashback gagné",
      readyToExchange: "Prêt à échanger ?",
      cashbackBenefit: "Bénéficiez de cashback sur vos échanges",
      exchangeNow: "Échanger maintenant",
      wallet: "Portefeuille",
      cashback: "Cashback",
      progression: "Progression",
      earned: "Gagné",
      currentRate: "Taux actuel",
      exchangeHistory: "Historique des échanges",
      verifyIdentity: "Vérifier mon identité",
      notVerified: "Non vérifié",
      pending: "En cours",
      verified: "Vérifié",
      rejected: "Rejeté"
    },
    kyc: {
      title: "Vérification d'identité (KYC)",
      subtitle: "Vérifiez votre identité pour accéder à toutes les fonctionnalités",
      step1: "Informations personnelles",
      step2: "Pièce d'identité",
      step3: "Selfie de vérification",
      firstName: "Prénom",
      lastName: "Nom",
      dateOfBirth: "Date de naissance",
      nationality: "Nationalité",
      address: "Adresse",
      city: "Ville",
      phone: "Téléphone",
      idType: "Type de document",
      idNumber: "Numéro du document",
      passport: "Passeport",
      idCard: "Carte d'identité nationale",
      driverLicense: "Permis de conduire",
      residencePermit: "Titre de séjour",
      frontSide: "Recto du document",
      backSide: "Verso du document",
      selfie: "Selfie de vérification",
      uploadClick: "Cliquez pour upload",
      previous: "Précédent",
      next: "Suivant",
      submit: "Soumettre",
      submitting: "Envoi en cours...",
      pendingTitle: "Vérification en cours",
      pendingDesc: "Nous examinons vos documents. Délai estimé : 24-48 heures.",
      approvedTitle: "Identité vérifiée",
      approvedDesc: "Votre compte est entièrement vérifié.",
      backToDashboard: "Retour au Dashboard"
    },
    payment: {
      title: "Confirmation de paiement",
      requestNumber: "N° de demande",
      status: "Statut",
      awaitingPayment: "En attente de paiement",
      sendExactly: "Envoyez exactement",
      toAddress: "à l'adresse suivante",
      copyAddress: "Copier l'adresse",
      copied: "Copié !",
      timeRemaining: "Temps restant",
      youWillReceive: "Vous recevrez",
      hasPaid: "J'ai effectué le paiement",
      cancel: "Annuler"
    },
    footer: {
      description: "La plateforme d'échange crypto la plus rapide et sécurisée.",
      navigation: "Navigation",
      legal: "Légal",
      privacy: "Confidentialité",
      cookies: "Cookies",
      terms: "Conditions",
      contact: "Contact",
      copyright: "Tous droits réservés.",
      cryptoExchange: "Échange Crypto",
      buySell: "Acheter/Vendre",
      converter: "Convertisseur",
      paymentMethods: "Méthodes de paiement",
      bankTransfer: "Virement bancaire",
      prepaidCards: "Cartes prépayées",
      paymentAcceptance: "Accepter les paiements",
      businessAccount: "Compte Business",
      merchantTools: "Outils marchands",
      company: "Entreprise",
      aboutUs: "À propos",
      helpCenter: "Centre d'aide",
      blog: "Blog",
      careers: "Carrières",
      resources: "Ressources",
      fees: "Frais",
      referral: "Parrainage",
      security: "Sécurité",
      followUs: "Suivez-nous",
      downloadApp: "Télécharger l'app",
      downloadOn: "Télécharger sur",
      getItOn: "Disponible sur",
      recommendedBy: "Recommandé par"
    },
    stats: {
      activeUsers: "Utilisateurs actifs",
      volumeExchanged: "Volume échangé",
      cryptos: "Cryptomonnaies",
      avgTime: "Temps moyen"
    },
    faq: {
      title: "Questions fréquentes",
      subtitle: "Tout ce que vous devez savoir",
      q1: "Comment effectuer un échange sur notre service ?",
      a1: "Sélectionnez la cryptomonnaie à échanger, entrez le montant, choisissez votre méthode de paiement, puis confirmez. Vous recevez vos fonds en quelques minutes après vérification.",
      q2: "Combien de temps dure l'échange ?",
      a2: "La plupart des échanges sont traités en 5 à 15 minutes. Les virements bancaires peuvent prendre 1-2 jours ouvrables.",
      q3: "Quels sont vos frais de transaction ?",
      a3: "Une commission unique de 7% tout compris s'applique à chaque opération (achat, vente, envoi). Aucun frais caché : le montant exact est affiché avant de valider.",
      q4: "Quelles méthodes de paiement acceptez-vous ?",
      a4: "Nous acceptons : virements SEPA, Revolut, Carte Visa, Mastercard, Cashlib, Transcash, Neosurf, PCS Mastercard.",
      q5: "Mes données sont-elles sécurisées ?",
      a5: "Absolument ! Nous utilisons un chiffrement de niveau bancaire pour protéger vos données.",
      q6: "Comment fonctionne le programme de parrainage ?",
      a6: "Partagez votre lien unique avec vos amis. Vous recevez 10% de commission sur leurs frais de transaction, à vie !"
    },
    reviews: {
      title: "Derniers avis",
      r1: "Service rapide et fiable ! Transaction en moins de 5 minutes.",
      r2: "Excellent taux de change. Je recommande vivement cette plateforme.",
      r3: "Interface intuitive et support client très réactif. Parfait !",
      r4: "Meilleure plateforme d'échange que j'ai utilisée. Très professionnelle.",
      r5: "Frais très compétitifs et transactions ultra-rapides.",
      r6: "Le virement SEPA fonctionne parfaitement. Excellente plateforme !"
    },
    admin: {
      title: "Panel Admin",
      subtitle: "Gestion des demandes d'échange",
      refresh: "Actualiser",
      users: "Utilisateurs",
      pendingRequests: "En attente",
      completedRequests: "Complétées",
      totalVolume: "Volume total",
      exchangeRequests: "Demandes d'échange",
      usersTab: "Utilisateurs",
      allStatuses: "Tous les statuts",
      noRequests: "Aucune demande trouvée",
      requestNumber: "N° Demande",
      email: "Email",
      gives: "Donne",
      receives: "Reçoit",
      status: "Statut",
      date: "Date",
      actions: "Actions",
      name: "Nom",
      role: "Rôle",
      level: "Niveau",
      volume: "Volume",
      cashback: "Cashback",
      registeredOn: "Inscrit le",
      pending: "En attente",
      confirming: "À confirmer",
      processing: "En cours",
      completed: "Terminé",
      cancelled: "Annulé",
      rejected: "Rejeté"
    },
    sendMoney: {
      badge: "Envoi d'argent international",
      title: "Envoyez de l'argent simplement",
      subtitle: "Transférez de l'argent vers l'Europe, l'Asie et la Russie. Rapide, sécurisé et transparent.",
      promoTitle: "Envoyez de l'argent à l'international",
      promoDesc: "Simple comme un virement. Envoyez de l'argent en Europe, Asie et Russie sans vous soucier des cryptomonnaies.",
      cta: "Envoyer maintenant",
      step1: "Combien envoyez-vous ?",
      step2: "Destinataire",
      step3: "Confirmation",
      youSend: "Vous envoyez",
      destination: "Destination",
      theyReceive: "Le destinataire reçoit",
      commission: "Commission",
      rate: "Taux de change",
      continue: "Continuer",
      back: "Retour",
      recipientName: "Nom complet du destinataire",
      recipientPhone: "Téléphone du destinataire",
      yourEmail: "Votre email",
      confirmSend: "Confirmer l'envoi",
      success: "Transfert initié !",
      successDesc: "Votre demande de transfert a été envoyée. Vous recevrez un email avec les instructions.",
      backHome: "Retour à l'accueil",
      destinations: "Destinations populaires",
      secure: "Transfert sécurisé",
      fast: "24-48h",
      users: "utilisateurs"
    }
  },

  en: {
    p2pExtra: {
      channelClosed: 'Direct Trading temporarily closed', operatorInfo: 'Operator information',
      companyCounterparty: 'Counterparty: alphaswapp — you are the Taker', p2pCounterparty: 'P2P — trade between clients',
      delayWarning: 'Processing may take up to 24 additional hours in case of enhanced verification, payment integrity checks or unforeseen issues. Thank you for your patience.',
      sendCryptoAdmin: 'Send the crypto to the address provided by the operator:',
      payToCardAdmin: 'Send the payment to the card provided by the operator, then upload the receipt:',
      waitingCardInfo: 'The operator will share the payment details here. You can also contact them via the support chat.',
      waitingEscrow: "Waiting for the seller's crypto escrow...",
      grossAmount: 'Gross amount', commission7: 'Commission 7%', youReceive: 'You will receive',
      buyerWillGet: 'Passed to buyer', buyerGets: 'Buyer receives', chooseBank: 'Your bank',
      cancelBtn: 'Cancel',
      autoPrice: 'Unit price — market rate (automatic)', liveRate: 'Live',
      sellerEscrowPending: 'Crypto declared sent — the operator is verifying the escrow reception.',
      sellerEscrowReceived: "Escrow confirmed ✓ — waiting for the buyer's payment.",
      sellerFiatSent: 'The buyer declared the payment — the operator is verifying the receipt before finalizing.',
    },
    support: {
      title: 'alphaswapp Support', online: 'Online — fast reply',
      empty: 'A question about your transaction? Write to us, our team replies here.',
      placeholder: 'Your message...', tooBig: 'File too large (max 10 MB)',
      telegram: 'Or write to us on Telegram: @alphaswapp',
    },
    fiatlive: { title: 'Live fiat rates' },
    alerts: {
      navLabel: 'Alerts', badge: 'Real time', title: 'Price alerts',
      subtitle: 'Get notified the moment a price hits your threshold, even when the tab is closed.',
      enableNotifs: 'Enable notifications', disableNotifs: 'Disable notifications',
      notifsEnabled: 'Notifications enabled!', notifsDisabled: 'Notifications disabled',
      notifsBlocked: 'Notifications blocked by your browser. Allow them in the site settings.',
      notSupported: 'Browser not supported', createTitle: 'New alert', crypto: 'Crypto',
      condition: 'Condition', above: 'Above', below: 'Below', targetPrice: 'Target price',
      currentPrice: 'Current price', create: 'Create alert', creating: 'Creating...',
      created: 'Alert created!', deleted: 'Alert deleted', invalidPrice: 'Invalid target price',
      error: 'Something went wrong', activeTitle: 'Active alerts',
      noActive: 'No active alerts. Create one to get notified.',
      triggeredTitle: 'Triggered alerts', triggeredAt: 'Triggered at',
      enableHint: 'Enable notifications to be alerted even in the background',
      manage: 'Manage', noActiveShort: 'No active alerts.', createOne: 'Create an alert',
    },
    p2p: {
      badge: 'New',
      title: 'Direct Trading',
      subtitle: 'Buy and sell directly with other users. Your funds are secured in escrow by alphaswapp until the transaction completes.',
      buy: 'Buy',
      sell: 'Sell',
      orderbook: 'Order book',
      myOrders: 'My orders',
      createOrder: 'Create order',
      amount: 'Amount',
      price: 'Unit price',
      total: 'Total',
      commission: 'Seller fee 7%',
      noOrders: 'No orders available. Create yours!',
      takeOrder: 'Take this order',
      waiting: 'Waiting for a counterparty',
      matched: 'Counterparty found',
      escrowPending: 'Crypto being verified',
      escrowReceived: 'Crypto in escrow',
      fiatSent: 'Payment sent',
      completed: 'Completed',
      cancelled: 'Cancelled',
      sendCrypto: 'Send the crypto to the alphaswapp wallet',
      uploadReceipt: 'Upload bank receipt',
      iSent: 'I sent the crypto',
      bankCard: 'Bank card',
      bankName: 'Bank',
      walletAddr: 'Your wallet address',
      network: 'Network',
      escrowInfo: 'Funds blocked for max 45 minutes',
      howTitle: 'How does it work?',
      how1: 'The seller sends crypto to the secure alphaswapp wallet',
      how2: 'The buyer sends the bank payment directly to the seller',
      how3: 'After receipt verification, crypto is released to the buyer',
      presentTitle: 'Trade directly, together',
      presentDesc: 'A peer-to-peer order book with secure escrow: your orders stay live until a counterparty is found.',
      cta: 'Discover Direct Trading',
    },
    common: {
      quickCalc: 'Calculate your exchange live',
      authSubtitle: 'Access your alphaswapp account',
      dashboard: 'Dashboard',
      logout: 'Log out',
      level: 'Level',
      high: 'High',
      low: 'Low',
      variation: 'Change',
      price: 'Price',
      transferSuccess: 'Your transfer request has been sent!',
      invalidAmount: 'Invalid amount',
      nameRequired: 'Name required',
      phoneRequired: 'Phone required',
      invalidEmail: 'Invalid email',
      start: 'Start',
      continueGoogle: 'Continue with Google',
      loading: 'Loading...',
      processing: 'Processing...',
      home: 'Home',
      rateLocked: 'Rate locked',
      rateLockInfo: 'Rate guaranteed for 10 minutes',
      lockExpired: 'Rate expired, refreshing...',
      kycRequired: 'Identity verification required',
      kycRequiredDesc: 'Complete your KYC to increase your exchange limits',
      secure: 'Secure',
      fast: 'Fast',
      recentExchanges: 'Recent exchanges',
      sent: 'Sent',
      received: 'Received',
      date: 'Date',
      direction: 'Direction',
      commission: 'Commission',
      exchangeTime: 'Exchange time',
      supportAvailable: 'Support available',
      liveRates: 'Live prices',
    },
    nav: {
      exchange: "Exchange",
      cards: "Cards",
      business: "Business",
      privacy: "Privacy",
      login: "Login",
      logout: "Logout",
      dashboard: "Dashboard",
      admin: "Admin",
      sendMoney: "Send Money",
      home: "Home"
    },
    hero: {
      calcDesc: 'Rates refreshed every 30 seconds. Lock your price for 10 minutes when you transact.',
      rateLock: 'Rate locked 10 min',
      darkTitle: 'One single fee. Zero surprises.',
      darkDesc: '7% all-inclusive on every operation — buy, sell, send. No hidden fees, no bad surprises.',
      commissionTitle: '7% all inclusive',
      commissionDesc: 'One transparent fee on every operation. Shown before you confirm.',

      badge: "Ultra-fast crypto exchange",
      title: "Exchange your cryptos",
      titleHighlight: "securely",
      description: "The fastest and most secure exchange platform. Support for 20+ cryptocurrencies with the best market rates.",
      startBtn: "Get started now",
      apiBtn: "Developer API"
    },
    exchangeWidget: {
      title: "Quick Converter",
      youSend: "You send",
      youReceive: "You receive",
      youGive: "You give",
      rate: "Exchange rate",
      fees: "Fees",
      exchange: "Exchange now",
      buy: "Buy",
      sell: "Sell",
      selectCrypto: "Select crypto",
      selectPayment: "Select payment",
      enterAmount: "Enter amount",
      accountInfo: "Account information",
      email: "Email",
      continue: "Continue",
      confirm: "Confirm exchange"
    },
    features: {
      title: "Why choose alphaswapp?",
      speed: {
        title: "Instant exchanges",
        description: "Receive your funds in minutes with our automated system"
      },
      security: {
        title: "100% Secure",
        description: "Your transactions are protected by advanced security protocols"
      },
      support: {
        title: "24/7 Support",
        description: "Our team is available to help you anytime"
      }
    },
    recentExchanges: {
      title: "Recent exchanges",
      ago: "ago"
    },
    reviews: {
      title: "Latest reviews"
    },
    services: {
      exchange: "Exchange",
      qrPayment: "QR Payment",
      mobileMoney: "Prepaid Cards",
      bankTransfer: "Bank Transfer",
      wallet: "Wallet",
      send: "Send",
      cashback: "Cashback"
    },
    auth: {
      login: "Login",
      register: "Register",
      email: "Email",
      password: "Password",
      phone: "Phone",
      loginBtn: "Login",
      registerBtn: "Register",
      googleBtn: "Continue with Google",
      or: "or",
      noAccount: "Don't have an account?",
      hasAccount: "Already have an account?",
      terms: "By logging in, you agree to our",
      termsLink: "Terms of Service",
      privacyLink: "Privacy Policy"
    },
    dashboard: {
      welcome: "Hello",
      overview: "Here's an overview of your account",
      totalValue: "Total value",
      totalVolume: "Total volume",
      vipLevel: "VIP Level",
      cashbackEarned: "Cashback earned",
      readyToExchange: "Ready to exchange?",
      cashbackBenefit: "Get cashback on your exchanges",
      exchangeNow: "Exchange now",
      wallet: "Wallet",
      cashback: "Cashback",
      progression: "Progression",
      earned: "Earned",
      currentRate: "Current rate",
      exchangeHistory: "Exchange history",
      verifyIdentity: "Verify my identity",
      notVerified: "Not verified",
      pending: "Pending",
      verified: "Verified",
      rejected: "Rejected"
    },
    kyc: {
      title: "Identity Verification (KYC)",
      subtitle: "Verify your identity to access all features",
      step1: "Personal information",
      step2: "ID Document",
      step3: "Verification selfie",
      firstName: "First name",
      lastName: "Last name",
      dateOfBirth: "Date of birth",
      nationality: "Nationality",
      address: "Address",
      city: "City",
      phone: "Phone",
      idType: "Document type",
      idNumber: "Document number",
      passport: "Passport",
      idCard: "National ID card",
      driverLicense: "Driver's license",
      residencePermit: "Residence permit",
      frontSide: "Front side",
      backSide: "Back side",
      selfie: "Verification selfie",
      uploadClick: "Click to upload",
      previous: "Previous",
      next: "Next",
      submit: "Submit",
      submitting: "Submitting...",
      pendingTitle: "Verification in progress",
      pendingDesc: "We are reviewing your documents. Estimated time: 24-48 hours.",
      approvedTitle: "Identity verified",
      approvedDesc: "Your account is fully verified.",
      backToDashboard: "Back to Dashboard"
    },
    payment: {
      title: "Payment confirmation",
      requestNumber: "Request #",
      status: "Status",
      awaitingPayment: "Awaiting payment",
      sendExactly: "Send exactly",
      toAddress: "to the following address",
      copyAddress: "Copy address",
      copied: "Copied!",
      timeRemaining: "Time remaining",
      youWillReceive: "You will receive",
      hasPaid: "I have made the payment",
      cancel: "Cancel"
    },
    footer: {
      description: "The fastest and most secure crypto exchange platform.",
      navigation: "Navigation",
      legal: "Legal",
      privacy: "Privacy",
      cookies: "Cookies",
      terms: "Terms",
      contact: "Contact",
      copyright: "All rights reserved.",
      cryptoExchange: "Crypto Exchange",
      buySell: "Buy/Sell",
      converter: "Converter",
      paymentMethods: "Payment Methods",
      bankTransfer: "Bank Transfer",
      prepaidCards: "Prepaid Cards",
      paymentAcceptance: "Accept Payments",
      businessAccount: "Business Account",
      merchantTools: "Merchant Tools",
      company: "Company",
      aboutUs: "About Us",
      helpCenter: "Help Center",
      blog: "Blog",
      careers: "Careers",
      resources: "Resources",
      fees: "Fees",
      referral: "Referral",
      security: "Security",
      followUs: "Follow Us",
      downloadApp: "Download the App",
      downloadOn: "Download on",
      getItOn: "Get it on",
      recommendedBy: "Recommended by"
    },
    stats: {
      activeUsers: "Active users",
      volumeExchanged: "Volume exchanged",
      cryptos: "Cryptocurrencies",
      avgTime: "Average time"
    },
    faq: {
      title: "Frequently Asked Questions",
      subtitle: "Everything you need to know",
      q1: "How do I make an exchange on your service?",
      a1: "Select the cryptocurrency to exchange, enter the amount, choose your payment method, then confirm. You'll receive your funds within minutes after verification.",
      q2: "How long does the exchange take?",
      a2: "Most exchanges are processed in 5 to 15 minutes. Bank transfers may take 1-2 business days.",
      q3: "What are your transaction fees?",
      a3: "A single all-inclusive 7% fee applies to every operation (buy, sell, send). No hidden fees: the exact amount is shown before you confirm.",
      q4: "What payment methods do you accept?",
      a4: "We accept: SEPA transfers, Revolut, Visa, Mastercard, Cashlib, Transcash, Neosurf, PCS Mastercard.",
      q5: "Is my data secure?",
      a5: "Absolutely! We use bank-grade encryption to protect your data.",
      q6: "How does the referral program work?",
      a6: "Share your unique link with friends. You receive 10% commission on their transaction fees, for life!"
    },
    reviews: {
      title: "Latest Reviews",
      r1: "Fast and reliable service! Transaction in less than 5 minutes.",
      r2: "Excellent exchange rate. I highly recommend this platform.",
      r3: "Intuitive interface and very responsive customer support. Perfect!",
      r4: "Best exchange platform I've used. Very professional.",
      r5: "Very competitive fees and ultra-fast transactions.",
      r6: "SEPA transfer works perfectly. Excellent platform!"
    },
    admin: {
      title: "Admin Panel",
      subtitle: "Exchange request management",
      refresh: "Refresh",
      users: "Users",
      pendingRequests: "Pending",
      completedRequests: "Completed",
      totalVolume: "Total volume",
      exchangeRequests: "Exchange requests",
      usersTab: "Users",
      allStatuses: "All statuses",
      noRequests: "No requests found",
      requestNumber: "Request #",
      email: "Email",
      gives: "Gives",
      receives: "Receives",
      status: "Status",
      date: "Date",
      actions: "Actions",
      name: "Name",
      role: "Role",
      level: "Level",
      volume: "Volume",
      cashback: "Cashback",
      registeredOn: "Registered on",
      pending: "Pending",
      confirming: "Confirming",
      processing: "Processing",
      completed: "Completed",
      cancelled: "Cancelled",
      rejected: "Rejected"
    }
  },

  es: {
    p2pExtra: {
      channelClosed: 'Trading Directo cerrado temporalmente', operatorInfo: 'Información del operador',
      companyCounterparty: 'Contraparte: alphaswapp — usted es el Taker', p2pCounterparty: 'P2P — intercambio entre clientes',
      delayWarning: 'El procesamiento puede requerir hasta 24 horas adicionales en caso de verificación reforzada, control de integridad del pago o imprevistos. Gracias por su paciencia.',
      sendCryptoAdmin: 'Envíe la cripto a la dirección comunicada por el operador:',
      payToCardAdmin: 'Envíe el pago a la tarjeta comunicada por el operador y luego suba el recibo:',
      waitingCardInfo: 'El operador le comunicará los datos de pago aquí. También puede contactarlo por el chat de soporte.',
      waitingEscrow: 'Esperando el depósito cripto del vendedor...',
      grossAmount: 'Importe bruto', commission7: 'Comisión 7%', youReceive: 'Usted recibirá',
      buyerWillGet: 'Transmitido al comprador', buyerGets: 'El comprador recibe', chooseBank: 'Su banco',
      cancelBtn: 'Cancelar',
      autoPrice: 'Preço unitário — taxa de mercado (automático)', liveRate: 'Ao vivo',
      autoPrice: 'Precio unitario — tasa de mercado (automático)', liveRate: 'En vivo',
      sellerEscrowPending: 'Cripto declarada enviada — el operador verifica la recepción del depósito.',
      sellerEscrowReceived: 'Depósito confirmado ✓ — a la espera del pago del comprador.',
      sellerFiatSent: 'El comprador declaró el pago — el operador verifica el recibo antes de finalizar.',
    },
    support: {
      title: 'Soporte alphaswapp', online: 'En línea — respuesta rápida',
      empty: '¿Una pregunta sobre su transacción? Escríbanos, nuestro equipo le responde aquí.',
      placeholder: 'Su mensaje...', tooBig: 'Archivo demasiado grande (máx. 10 MB)',
      telegram: 'O escríbanos en Telegram: @alphaswapp',
    },
    fiatlive: { title: 'Tipos fiat en directo' },
    alerts: {
      navLabel: 'Alertas', badge: 'Tiempo real', title: 'Alertas de precio',
      subtitle: 'Recibe una notificación en cuanto el precio alcance tu umbral, incluso con la pestaña cerrada.',
      enableNotifs: 'Activar notificaciones', disableNotifs: 'Desactivar notificaciones',
      notifsEnabled: '¡Notificaciones activadas!', notifsDisabled: 'Notificaciones desactivadas',
      notifsBlocked: 'Notificaciones bloqueadas por el navegador. Permítelas en la configuración del sitio.',
      notSupported: 'Navegador no compatible', createTitle: 'Nueva alerta', crypto: 'Cripto',
      condition: 'Condición', above: 'Por encima de', below: 'Por debajo de', targetPrice: 'Precio objetivo',
      currentPrice: 'Precio actual', create: 'Crear alerta', creating: 'Creando...',
      created: '¡Alerta creada!', deleted: 'Alerta eliminada', invalidPrice: 'Precio objetivo no válido',
      error: 'Se produjo un error', activeTitle: 'Alertas activas',
      noActive: 'No hay alertas activas. Crea una para recibir notificaciones.',
      triggeredTitle: 'Alertas activadas', triggeredAt: 'Activada a',
      enableHint: 'Activa las notificaciones para recibir alertas incluso en segundo plano',
      manage: 'Gestionar', noActiveShort: 'Sin alertas activas.', createOne: 'Crear una alerta',
    },
    p2p: {
      badge: 'Nuevo',
      title: 'Trading Directo',
      subtitle: 'Compra y vende directamente con otros usuarios. Sus fondos están asegurados en custodia por alphaswapp hasta completar la transacción.',
      buy: 'Comprar',
      sell: 'Vender',
      orderbook: 'Libro de órdenes',
      myOrders: 'Mis órdenes',
      createOrder: 'Crear orden',
      amount: 'Cantidad',
      price: 'Precio unitario',
      total: 'Total',
      commission: 'Comisión vendedor 7%',
      noOrders: 'No hay órdenes disponibles. ¡Crea la tuya!',
      takeOrder: 'Tomar esta orden',
      waiting: 'Esperando contraparte',
      matched: 'Contraparte encontrada',
      escrowPending: 'Cripto en verificación',
      escrowReceived: 'Cripto en custodia',
      fiatSent: 'Pago enviado',
      completed: 'Completado',
      cancelled: 'Cancelado',
      sendCrypto: 'Envía la cripto a la billetera alphaswapp',
      uploadReceipt: 'Subir recibo bancario',
      iSent: 'Envié la cripto',
      bankCard: 'Tarjeta bancaria',
      bankName: 'Banco',
      walletAddr: 'Dirección de tu billetera',
      network: 'Red',
      escrowInfo: 'Fondos bloqueados máximo 45 minutos',
      howTitle: '¿Cómo funciona?',
      how1: 'El vendedor envía la cripto a la billetera segura de alphaswapp',
      how2: 'El comprador envía el pago bancario directamente al vendedor',
      how3: 'Tras verificar el recibo, la cripto se libera al comprador',
      presentTitle: 'Opera en directo, entre usuarios',
      presentDesc: 'Un libro de órdenes P2P con custodia segura: tus órdenes permanecen activas hasta encontrar contraparte.',
      cta: 'Descubrir Trading Directo',
    },
    common: {
      quickCalc: 'Calcula tu intercambio en vivo',
      authSubtitle: 'Accede a tu cuenta alphaswapp',
      dashboard: 'Panel',
      logout: 'Cerrar sesión',
      level: 'Nivel',
      high: 'Máximo',
      low: 'Mínimo',
      variation: 'Variación',
      price: 'Precio',
      transferSuccess: '¡Tu solicitud de transferencia ha sido enviada!',
      invalidAmount: 'Cantidad inválida',
      nameRequired: 'Nombre requerido',
      phoneRequired: 'Teléfono requerido',
      invalidEmail: 'Email inválido',
      start: 'Empezar',
      continueGoogle: 'Continuar con Google',
      loading: 'Cargando...',
      processing: 'Procesando...',
      home: 'Inicio',
      rateLocked: 'Tasa bloqueada',
      rateLockInfo: 'Tasa garantizada durante 10 minutos',
      lockExpired: 'La tasa expiró, actualizando...',
      kycRequired: 'Verificación de identidad requerida',
      kycRequiredDesc: 'Completa tu KYC para aumentar tus límites de intercambio',
      secure: 'Seguro',
      fast: 'Rápido',
      recentExchanges: 'Intercambios recientes',
      sent: 'Enviado',
      received: 'Recibido',
      date: 'Fecha',
      direction: 'Dirección',
      commission: 'Comisión',
      exchangeTime: 'Tiempo de intercambio',
      supportAvailable: 'Soporte disponible',
      liveRates: 'Precios en tiempo real',
    },
    nav: {
      exchange: "Intercambio",
      cards: "Tarjetas",
      business: "Negocios",
      privacy: "Privacidad",
      login: "Iniciar sesión",
      logout: "Cerrar sesión",
      dashboard: "Panel",
      admin: "Admin",
      home: "Inicio",
      sendMoney: "Envío de dinero",
    },
    hero: {
      calcDesc: 'Tasas actualizadas cada 30 segundos. Bloquea tu precio durante 10 minutos al realizar la transacción.',
      rateLock: 'Tasa bloqueada 10 min',
      darkTitle: 'Una única comisión. Cero sorpresas.',
      darkDesc: '7% todo incluido en cada operación — compra, venta, envío. Sin comisiones ocultas.',
      commissionTitle: '7% todo incluido',
      commissionDesc: 'Una sola comisión transparente en cada operación. Visible antes de confirmar.',

      badge: "Intercambio cripto ultrarrápido",
      title: "Intercambia tus criptos con total",
      titleHighlight: "seguridad",
      description: "La plataforma de intercambio más rápida y segura. Soporte para más de 20 criptomonedas con las mejores tasas del mercado.",
      startBtn: "Comenzar ahora",
      apiBtn: "API para desarrolladores"
    },
    exchangeWidget: {
      title: "Conversor Rápido",
      youSend: "Envías",
      youReceive: "Recibes",
      youGive: "Das",
      rate: "Tipo de cambio",
      fees: "Comisiones",
      exchange: "Intercambiar ahora",
      buy: "Comprar",
      sell: "Vender",
      selectCrypto: "Seleccionar cripto",
      selectPayment: "Seleccionar pago",
      enterAmount: "Ingresa el monto",
      accountInfo: "Información de la cuenta",
      email: "Correo electrónico",
      continue: "Continuar",
      confirm: "Confirmar intercambio"
    },
    features: {
      title: "¿Por qué elegir alphaswapp?",
      speed: {
        title: "Intercambios instantáneos",
        description: "Recibe tus fondos en minutos con nuestro sistema automatizado"
      },
      security: {
        title: "100% Seguro",
        description: "Tus transacciones están protegidas por protocolos de seguridad avanzados"
      },
      support: {
        title: "Soporte 24/7",
        description: "Nuestro equipo está disponible para ayudarte en cualquier momento"
      }
    },
    recentExchanges: {
      title: "Intercambios recientes",
      ago: "hace"
    },
    reviews: {
      title: "Últimas opiniones"
    },
    services: {
      exchange: "Intercambio",
      qrPayment: "Pago QR",
      mobileMoney: "Tarjetas Prepago",
      bankTransfer: "Transferencia",
      cards: "Tarjetas",
      wallet: "Billetera",
      send: "Enviar",
      cashback: "Cashback"
    },
    auth: {
      login: "Iniciar sesión",
      register: "Registrarse",
      email: "Correo electrónico",
      password: "Contraseña",
      phone: "Teléfono",
      loginBtn: "Iniciar sesión",
      registerBtn: "Registrarse",
      googleBtn: "Continuar con Google",
      or: "o",
      noAccount: "¿No tienes cuenta?",
      hasAccount: "¿Ya tienes cuenta?",
      terms: "Al iniciar sesión, aceptas nuestros",
      termsLink: "Términos de servicio",
      privacyLink: "Política de privacidad"
    },
    dashboard: {
      welcome: "Hola",
      overview: "Aquí tienes un resumen de tu cuenta",
      totalValue: "Valor total",
      totalVolume: "Volumen total",
      vipLevel: "Nivel VIP",
      cashbackEarned: "Cashback ganado",
      readyToExchange: "¿Listo para intercambiar?",
      cashbackBenefit: "Obtén cashback en tus intercambios",
      exchangeNow: "Intercambiar ahora",
      wallet: "Billetera",
      cashback: "Cashback",
      progression: "Progreso",
      earned: "Ganado",
      currentRate: "Tasa actual",
      exchangeHistory: "Historial de intercambios",
      verifyIdentity: "Verificar mi identidad",
      notVerified: "No verificado",
      pending: "Pendiente",
      verified: "Verificado",
      rejected: "Rechazado"
    },
    kyc: {
      title: "Verificación de identidad (KYC)",
      subtitle: "Verifica tu identidad para acceder a todas las funciones",
      step1: "Información personal",
      step2: "Documento de identidad",
      step3: "Selfie de verificación",
      firstName: "Nombre",
      lastName: "Apellido",
      dateOfBirth: "Fecha de nacimiento",
      nationality: "Nacionalidad",
      address: "Dirección",
      city: "Ciudad",
      phone: "Teléfono",
      idType: "Tipo de documento",
      idNumber: "Número de documento",
      passport: "Pasaporte",
      idCard: "DNI",
      driverLicense: "Licencia de conducir",
      residencePermit: "Permiso de residencia",
      frontSide: "Anverso",
      backSide: "Reverso",
      selfie: "Selfie de verificación",
      uploadClick: "Clic para subir",
      previous: "Anterior",
      next: "Siguiente",
      submit: "Enviar",
      submitting: "Enviando...",
      pendingTitle: "Verificación en proceso",
      pendingDesc: "Estamos revisando tus documentos. Tiempo estimado: 24-48 horas.",
      approvedTitle: "Identidad verificada",
      approvedDesc: "Tu cuenta está completamente verificada.",
      backToDashboard: "Volver al Panel"
    },
    payment: {
      title: "Confirmación de pago",
      requestNumber: "N° de solicitud",
      status: "Estado",
      awaitingPayment: "Esperando pago",
      sendExactly: "Envía exactamente",
      toAddress: "a la siguiente dirección",
      copyAddress: "Copiar dirección",
      copied: "¡Copiado!",
      timeRemaining: "Tiempo restante",
      youWillReceive: "Recibirás",
      hasPaid: "He realizado el pago",
      cancel: "Cancelar"
    },
    footer: {
      description: "La plataforma de intercambio cripto más rápida y segura.",
      navigation: "Navegación",
      legal: "Legal",
      privacy: "Privacidad",
      cookies: "Cookies",
      terms: "Términos",
      contact: "Contacto",
      copyright: "Todos los derechos reservados.",
      cryptoExchange: "Intercambio Cripto",
      buySell: "Comprar/Vender",
      converter: "Convertidor",
      paymentMethods: "Métodos de Pago",
      bankTransfer: "Transferencia Bancaria",
      prepaidCards: "Tarjetas Prepago",
      paymentAcceptance: "Aceptar Pagos",
      businessAccount: "Cuenta Business",
      merchantTools: "Herramientas Comerciales",
      company: "Empresa",
      aboutUs: "Sobre Nosotros",
      helpCenter: "Centro de Ayuda",
      blog: "Blog",
      careers: "Empleos",
      resources: "Recursos",
      fees: "Tarifas",
      referral: "Referidos",
      security: "Seguridad",
      followUs: "Síguenos",
      downloadApp: "Descargar la App",
      downloadOn: "Descargar en",
      getItOn: "Disponible en",
      recommendedBy: "Recomendado por"
    },
    stats: {
      activeUsers: "Usuarios activos",
      volumeExchanged: "Volumen intercambiado",
      cryptos: "Criptomonedas",
      avgTime: "Tiempo promedio"
    },
    faq: {
      title: "Preguntas frecuentes",
      subtitle: "Todo lo que necesitas saber",
      q1: "¿Cómo realizar un intercambio en nuestro servicio?",
      a1: "Seleccione la criptomoneda a intercambiar, ingrese el monto, elija su método de pago y confirme.",
      q2: "¿Cuánto tiempo tarda el intercambio?",
      a2: "La mayoría de los intercambios se procesan en 5 a 15 minutos.",
      q3: "¿Cuáles son sus tarifas de transacción?",
      a3: "Se aplica una única comisión del 7% todo incluido a cada operación (compra, venta, envío). Sin comisiones ocultas: el importe exacto se muestra antes de confirmar.",
      q4: "¿Qué métodos de pago aceptan?",
      a4: "Aceptamos: transferencias SEPA, Revolut, Visa, Mastercard, Cashlib, Transcash, Neosurf, PCS Mastercard.",
      q5: "¿Mis datos están seguros?",
      a5: "¡Por supuesto! Utilizamos cifrado de nivel bancario para proteger sus datos.",
      q6: "¿Cómo funciona el programa de referidos?",
      a6: "Comparta su enlace único con amigos. Recibe 10% de comisión sobre sus tarifas de transacción, ¡de por vida!"
    },
    reviews: { title: "Últimas reseñas", r1: "Servicio rápido y fiable.", r2: "Excelente tipo de cambio.", r3: "Interfaz intuitiva.", r4: "Mejor plataforma de intercambio.", r5: "Tarifas muy competitivas.", r6: "La transferencia SEPA funciona perfectamente." },
    admin: { title: "Panel de Admin", subtitle: "Gestión de solicitudes", refresh: "Actualizar", users: "Usuarios", pendingRequests: "Pendientes", completedRequests: "Completadas", totalVolume: "Volumen total", exchangeRequests: "Solicitudes de intercambio", usersTab: "Usuarios", allStatuses: "Todos los estados", noRequests: "No se encontraron solicitudes", requestNumber: "N° Solicitud", email: "Email", gives: "Da", receives: "Recibe", status: "Estado", date: "Fecha", actions: "Acciones", name: "Nombre", role: "Rol", level: "Nivel", volume: "Volumen", cashback: "Cashback", registeredOn: "Registrado el", pending: "Pendiente", confirming: "Confirmando", processing: "Procesando", completed: "Completado", cancelled: "Cancelado", rejected: "Rechazado" }
  },

  pt: {
    p2pExtra: {
      channelClosed: 'Trading Direto temporariamente fechado', operatorInfo: 'Informação do operador',
      companyCounterparty: 'Contraparte: alphaswapp — você é o Taker', p2pCounterparty: 'P2P — troca entre clientes',
      delayWarning: 'O processamento pode exigir até 24 horas adicionais em caso de verificação reforçada, controle de integridade do pagamento ou imprevistos. Obrigado pela paciência.',
      sendCryptoAdmin: 'Envie a cripto para o endereço comunicado pelo operador:',
      payToCardAdmin: 'Envie o pagamento para o cartão comunicado pelo operador e depois envie o recibo:',
      waitingCardInfo: 'O operador comunicará os dados de pagamento aqui. Você também pode contatá-lo pelo chat de suporte.',
      waitingEscrow: 'Aguardando o depósito cripto do vendedor...',
      grossAmount: 'Valor bruto', commission7: 'Comissão 7%', youReceive: 'Você receberá',
      buyerWillGet: 'Transmitido ao comprador', buyerGets: 'O comprador recebe', chooseBank: 'Seu banco',
      cancelBtn: 'Cancelar',
      sellerEscrowPending: 'Cripto declarada enviada — o operador verifica a recepção do depósito.',
      sellerEscrowReceived: 'Depósito confirmado ✓ — aguardando o pagamento do comprador.',
      sellerFiatSent: 'O comprador declarou o pagamento — o operador verifica o recibo antes de finalizar.',
    },
    support: {
      title: 'Suporte alphaswapp', online: 'Online — resposta rápida',
      empty: 'Uma pergunta sobre sua transação? Escreva-nos, nossa equipe responde aqui.',
      placeholder: 'Sua mensagem...', tooBig: 'Arquivo muito grande (máx. 10 MB)',
      telegram: 'Ou escreva-nos no Telegram: @alphaswapp',
    },
    fiatlive: { title: 'Taxas fiat ao vivo' },
    alerts: {
      navLabel: 'Alertas', badge: 'Tempo real', title: 'Alertas de preço',
      subtitle: 'Receba uma notificação assim que o preço atingir o seu limite, mesmo com a aba fechada.',
      enableNotifs: 'Ativar notificações', disableNotifs: 'Desativar notificações',
      notifsEnabled: 'Notificações ativadas!', notifsDisabled: 'Notificações desativadas',
      notifsBlocked: 'Notificações bloqueadas pelo navegador. Permita-as nas configurações do site.',
      notSupported: 'Navegador não compatível', createTitle: 'Novo alerta', crypto: 'Cripto',
      condition: 'Condição', above: 'Acima de', below: 'Abaixo de', targetPrice: 'Preço-alvo',
      currentPrice: 'Preço atual', create: 'Criar alerta', creating: 'Criando...',
      created: 'Alerta criado!', deleted: 'Alerta excluído', invalidPrice: 'Preço-alvo inválido',
      error: 'Ocorreu um erro', activeTitle: 'Alertas ativos',
      noActive: 'Nenhum alerta ativo. Crie um para ser notificado.',
      triggeredTitle: 'Alertas acionados', triggeredAt: 'Acionado a',
      enableHint: 'Ative as notificações para ser alertado mesmo em segundo plano',
      manage: 'Gerenciar', noActiveShort: 'Nenhum alerta ativo.', createOne: 'Criar um alerta',
    },
    p2p: {
      badge: 'Novo',
      title: 'Trading Direto',
      subtitle: 'Compre e venda diretamente com outros usuários. Seus fundos ficam seguros em custódia pela alphaswapp até a conclusão.',
      buy: 'Comprar',
      sell: 'Vender',
      orderbook: 'Livro de ordens',
      myOrders: 'Minhas ordens',
      createOrder: 'Criar ordem',
      amount: 'Quantidade',
      price: 'Preço unitário',
      total: 'Total',
      commission: 'Taxa vendedor 7%',
      noOrders: 'Nenhuma ordem disponível. Crie a sua!',
      takeOrder: 'Aceitar esta ordem',
      waiting: 'Aguardando contraparte',
      matched: 'Contraparte encontrada',
      escrowPending: 'Cripto em verificação',
      escrowReceived: 'Cripto em custódia',
      fiatSent: 'Pagamento enviado',
      completed: 'Concluído',
      cancelled: 'Cancelado',
      sendCrypto: 'Envie a cripto para a carteira alphaswapp',
      uploadReceipt: 'Enviar recibo bancário',
      iSent: 'Enviei a cripto',
      bankCard: 'Cartão bancário',
      bankName: 'Banco',
      walletAddr: 'Endereço da sua carteira',
      network: 'Rede',
      escrowInfo: 'Fundos bloqueados por no máximo 45 minutos',
      howTitle: 'Como funciona?',
      how1: 'O vendedor envia a cripto para a carteira segura alphaswapp',
      how2: 'O comprador envia o pagamento bancário diretamente ao vendedor',
      how3: 'Após verificação do recibo, a cripto é liberada ao comprador',
      presentTitle: 'Negocie direto, entre vocês',
      presentDesc: 'Um livro de ordens P2P com custódia segura: suas ordens ficam ativas até encontrar contraparte.',
      cta: 'Descobrir Trading Direto',
    },
    common: {
      quickCalc: 'Calcule sua troca ao vivo',
      authSubtitle: 'Acesse sua conta alphaswapp',
      dashboard: 'Painel',
      logout: 'Sair',
      level: 'Nível',
      high: 'Máximo',
      low: 'Mínimo',
      variation: 'Variação',
      price: 'Preço',
      transferSuccess: 'Seu pedido de transferência foi enviado!',
      invalidAmount: 'Valor inválido',
      nameRequired: 'Nome obrigatório',
      phoneRequired: 'Telefone obrigatório',
      invalidEmail: 'Email inválido',
      start: 'Começar',
      continueGoogle: 'Continuar com Google',
      loading: 'Carregando...',
      processing: 'Processando...',
      home: 'Início',
      rateLocked: 'Taxa bloqueada',
      rateLockInfo: 'Taxa garantida por 10 minutos',
      lockExpired: 'A taxa expirou, atualizando...',
      kycRequired: 'Verificação de identidade necessária',
      kycRequiredDesc: 'Complete seu KYC para aumentar seus limites de troca',
      secure: 'Seguro',
      fast: 'Rápido',
      recentExchanges: 'Trocas recentes',
      sent: 'Enviado',
      received: 'Recebido',
      date: 'Data',
      direction: 'Direção',
      commission: 'Comissão',
      exchangeTime: 'Tempo de troca',
      supportAvailable: 'Suporte disponível',
      liveRates: 'Preços em tempo real',
    },
    nav: {
      exchange: "Câmbio",
      cards: "Cartões",
      business: "Negócios",
      privacy: "Privacidade",
      login: "Entrar",
      logout: "Sair",
      dashboard: "Painel",
      admin: "Admin",
      home: "Início",
      sendMoney: "Envio de dinheiro"
    },
    hero: {
      calcDesc: 'Taxas atualizadas a cada 30 segundos. Bloqueie seu preço por 10 minutos no momento da transação.',
      rateLock: 'Taxa bloqueada 10 min',
      darkTitle: 'Uma única comissão. Zero surpresas.',
      darkDesc: '7% tudo incluído em cada operação — compra, venda, envio. Sem taxas ocultas.',
      commissionTitle: '7% tudo incluído',
      commissionDesc: 'Uma única comissão transparente em cada operação. Exibida antes de confirmar.',

      badge: "Câmbio cripto ultrarrápido",
      title: "Troque suas criptos com total",
      titleHighlight: "segurança",
      description: "A plataforma de câmbio mais rápida e segura. Suporte para mais de 20 criptomoedas com as melhores taxas do mercado.",
      startBtn: "Começar agora",
      apiBtn: "API para desenvolvedores"
    },
    exchangeWidget: {
      title: "Conversor Rápido",
      youSend: "Você envia",
      youReceive: "Você recebe",
      youGive: "Você dá",
      rate: "Taxa de câmbio",
      fees: "Taxas",
      exchange: "Trocar agora",
      buy: "Comprar",
      sell: "Vender",
      selectCrypto: "Selecionar cripto",
      selectPayment: "Selecionar pagamento",
      enterAmount: "Digite o valor",
      accountInfo: "Informações da conta",
      email: "E-mail",
      continue: "Continuar",
      confirm: "Confirmar troca"
    },
    features: {
      title: "Por que escolher alphaswapp?",
      speed: {
        title: "Trocas instantâneas",
        description: "Receba seus fundos em minutos com nosso sistema automatizado"
      },
      security: {
        title: "100% Seguro",
        description: "Suas transações são protegidas por protocolos de segurança avançados"
      },
      support: {
        title: "Suporte 24/7",
        description: "Nossa equipe está disponível para ajudá-lo a qualquer momento"
      }
    },
    recentExchanges: {
      title: "Trocas recentes",
      ago: "atrás"
    },
    reviews: {
      title: "Últimas avaliações"
    },
    services: {
      exchange: "Câmbio",
      qrPayment: "Pagamento QR",
      mobileMoney: "Cartões Pré-pagos",
      bankTransfer: "Transferência",
      cards: "Cartões",
      wallet: "Carteira",
      send: "Enviar",
      cashback: "Cashback"
    },
    auth: {
      login: "Entrar",
      register: "Cadastrar",
      email: "E-mail",
      password: "Senha",
      phone: "Telefone",
      loginBtn: "Entrar",
      registerBtn: "Cadastrar",
      googleBtn: "Continuar com Google",
      or: "ou",
      noAccount: "Não tem conta?",
      hasAccount: "Já tem conta?",
      terms: "Ao entrar, você concorda com nossos",
      termsLink: "Termos de serviço",
      privacyLink: "Política de privacidade"
    },
    dashboard: {
      welcome: "Olá",
      overview: "Aqui está um resumo da sua conta",
      totalValue: "Valor total",
      totalVolume: "Volume total",
      vipLevel: "Nível VIP",
      cashbackEarned: "Cashback ganho",
      readyToExchange: "Pronto para trocar?",
      cashbackBenefit: "Ganhe cashback nas suas trocas",
      exchangeNow: "Trocar agora",
      wallet: "Carteira",
      cashback: "Cashback",
      progression: "Progresso",
      earned: "Ganho",
      currentRate: "Taxa atual",
      exchangeHistory: "Histórico de trocas",
      verifyIdentity: "Verificar minha identidade",
      notVerified: "Não verificado",
      pending: "Pendente",
      verified: "Verificado",
      rejected: "Rejeitado"
    },
    kyc: {
      title: "Verificação de identidade (KYC)",
      subtitle: "Verifique sua identidade para acessar todos os recursos",
      step1: "Informações pessoais",
      step2: "Documento de identidade",
      step3: "Selfie de verificação",
      firstName: "Nome",
      lastName: "Sobrenome",
      dateOfBirth: "Data de nascimento",
      nationality: "Nacionalidade",
      address: "Endereço",
      city: "Cidade",
      phone: "Telefone",
      idType: "Tipo de documento",
      idNumber: "Número do documento",
      passport: "Passaporte",
      idCard: "RG",
      driverLicense: "CNH",
      residencePermit: "Visto de residência",
      frontSide: "Frente",
      backSide: "Verso",
      selfie: "Selfie de verificação",
      uploadClick: "Clique para enviar",
      previous: "Anterior",
      next: "Próximo",
      submit: "Enviar",
      submitting: "Enviando...",
      pendingTitle: "Verificação em andamento",
      pendingDesc: "Estamos analisando seus documentos. Tempo estimado: 24-48 horas.",
      approvedTitle: "Identidade verificada",
      approvedDesc: "Sua conta está totalmente verificada.",
      backToDashboard: "Voltar ao Painel"
    },
    payment: {
      title: "Confirmação de pagamento",
      requestNumber: "N° do pedido",
      status: "Status",
      awaitingPayment: "Aguardando pagamento",
      sendExactly: "Envie exatamente",
      toAddress: "para o seguinte endereço",
      copyAddress: "Copiar endereço",
      copied: "Copiado!",
      timeRemaining: "Tempo restante",
      youWillReceive: "Você receberá",
      hasPaid: "Realizei o pagamento",
      cancel: "Cancelar"
    },
    footer: {
      description: "A plataforma de câmbio cripto mais rápida e segura.",
      navigation: "Navegação",
      legal: "Legal",
      privacy: "Privacidade",
      cookies: "Cookies",
      terms: "Termos",
      contact: "Contato",
      copyright: "Todos os direitos reservados.",
      cryptoExchange: "Câmbio Cripto",
      buySell: "Comprar/Vender",
      converter: "Conversor",
      paymentMethods: "Métodos de Pagamento",
      bankTransfer: "Transferência Bancária",
      prepaidCards: "Cartões Pré-pagos",
      paymentAcceptance: "Aceitar Pagamentos",
      businessAccount: "Conta Business",
      merchantTools: "Ferramentas Comerciais",
      company: "Empresa",
      aboutUs: "Sobre Nós",
      helpCenter: "Central de Ajuda",
      blog: "Blog",
      careers: "Carreiras",
      resources: "Recursos",
      fees: "Taxas",
      referral: "Indicação",
      security: "Segurança",
      followUs: "Siga-nos",
      downloadApp: "Baixar o App",
      downloadOn: "Baixar em",
      getItOn: "Disponível em",
      recommendedBy: "Recomendado por"
    },
    stats: {
      activeUsers: "Usuários ativos",
      volumeExchanged: "Volume trocado",
      cryptos: "Criptomoedas",
      avgTime: "Tempo médio"
    },
    faq: {
      title: "Perguntas frequentes",
      subtitle: "Tudo o que você precisa saber",
      q1: "Como fazer uma troca em nosso serviço?",
      a1: "Selecione a criptomoeda para trocar, insira o valor, escolha seu método de pagamento e confirme.",
      q2: "Quanto tempo leva a troca?",
      a2: "A maioria das trocas é processada em 5 a 15 minutos.",
      q3: "Quais são suas taxas de transação?",
      a3: "Uma única comissão de 7% tudo incluído aplica-se a cada operação (compra, venda, envio). Sem taxas ocultas: o valor exato é exibido antes de confirmar.",
      q4: "Quais métodos de pagamento vocês aceitam?",
      a4: "Aceitamos: transferências SEPA, Revolut, Visa, Mastercard, Cashlib, Transcash, Neosurf, PCS Mastercard.",
      q5: "Meus dados estão seguros?",
      a5: "Com certeza! Usamos criptografia de nível bancário para proteger seus dados.",
      q6: "Como funciona o programa de indicação?",
      a6: "Compartilhe seu link único com amigos. Você recebe 10% de comissão sobre suas taxas de transação, para sempre!"
    },
    reviews: { title: "Últimas avaliações", r1: "Serviço rápido e confiável.", r2: "Excelente taxa de câmbio.", r3: "Interface intuitiva.", r4: "Melhor plataforma de câmbio.", r5: "Taxas muito competitivas.", r6: "A transferência SEPA funciona perfeitamente." },
    admin: { title: "Painel Admin", subtitle: "Gestão de solicitações", refresh: "Atualizar", users: "Usuários", pendingRequests: "Pendentes", completedRequests: "Concluídas", totalVolume: "Volume total", exchangeRequests: "Solicitações de troca", usersTab: "Usuários", allStatuses: "Todos os status", noRequests: "Nenhuma solicitação encontrada", requestNumber: "N° Solicitação", email: "Email", gives: "Dá", receives: "Recebe", status: "Status", date: "Data", actions: "Ações", name: "Nome", role: "Função", level: "Nível", volume: "Volume", cashback: "Cashback", registeredOn: "Registrado em", pending: "Pendente", confirming: "Confirmando", processing: "Processando", completed: "Concluído", cancelled: "Cancelado", rejected: "Rejeitado" }
  },

  de: {
    p2pExtra: {
      channelClosed: 'Direct Trading vorübergehend geschlossen', operatorInfo: 'Information des Betreibers',
      companyCounterparty: 'Gegenpartei: alphaswapp — Sie sind der Taker', p2pCounterparty: 'P2P — Handel zwischen Kunden',
      delayWarning: 'Die Bearbeitung kann bei verstärkter Prüfung, Zahlungsintegritätskontrolle oder unvorhergesehenen Ereignissen bis zu 24 zusätzliche Stunden dauern. Vielen Dank für Ihre Geduld.',
      sendCryptoAdmin: 'Senden Sie die Krypto an die vom Betreiber mitgeteilte Adresse:',
      payToCardAdmin: 'Senden Sie die Zahlung an die vom Betreiber mitgeteilte Karte und laden Sie dann den Beleg hoch:',
      waitingCardInfo: 'Der Betreiber teilt Ihnen die Zahlungsdaten hier mit. Sie können ihn auch über den Support-Chat kontaktieren.',
      waitingEscrow: 'Warten auf die Krypto-Hinterlegung des Verkäufers...',
      grossAmount: 'Bruttobetrag', commission7: 'Kommission 7%', youReceive: 'Sie erhalten',
      buyerWillGet: 'An den Käufer übermittelt', buyerGets: 'Der Käufer erhält', chooseBank: 'Ihre Bank',
      cancelBtn: 'Abbrechen',
      autoPrice: 'Stückpreis — Marktkurs (automatisch)', liveRate: 'Live',
      sellerEscrowPending: 'Krypto als gesendet gemeldet — der Betreiber prüft den Eingang der Hinterlegung.',
      sellerEscrowReceived: 'Hinterlegung bestätigt ✓ — warten auf die Zahlung des Käufers.',
      sellerFiatSent: 'Der Käufer hat die Zahlung gemeldet — der Betreiber prüft den Beleg vor dem Abschluss.',
    },
    support: {
      title: 'alphaswapp Support', online: 'Online — schnelle Antwort',
      empty: 'Eine Frage zu Ihrer Transaktion? Schreiben Sie uns, unser Team antwortet hier.',
      placeholder: 'Ihre Nachricht...', tooBig: 'Datei zu groß (max. 10 MB)',
      telegram: 'Oder schreiben Sie uns auf Telegram: @alphaswapp',
    },
    fiatlive: { title: 'Live-Fiat-Kurse' },
    alerts: {
      navLabel: 'Alarme', badge: 'Echtzeit', title: 'Preisalarme',
      subtitle: 'Erhalten Sie eine Benachrichtigung, sobald der Preis Ihre Schwelle erreicht – auch bei geschlossenem Tab.',
      enableNotifs: 'Benachrichtigungen aktivieren', disableNotifs: 'Benachrichtigungen deaktivieren',
      notifsEnabled: 'Benachrichtigungen aktiviert!', notifsDisabled: 'Benachrichtigungen deaktiviert',
      notifsBlocked: 'Benachrichtigungen vom Browser blockiert. Erlauben Sie sie in den Website-Einstellungen.',
      notSupported: 'Browser nicht unterstützt', createTitle: 'Neuer Alarm', crypto: 'Krypto',
      condition: 'Bedingung', above: 'Über', below: 'Unter', targetPrice: 'Zielpreis',
      currentPrice: 'Aktueller Preis', create: 'Alarm erstellen', creating: 'Wird erstellt...',
      created: 'Alarm erstellt!', deleted: 'Alarm gelöscht', invalidPrice: 'Ungültiger Zielpreis',
      error: 'Ein Fehler ist aufgetreten', activeTitle: 'Aktive Alarme',
      noActive: 'Keine aktiven Alarme. Erstellen Sie einen, um benachrichtigt zu werden.',
      triggeredTitle: 'Ausgelöste Alarme', triggeredAt: 'Ausgelöst bei',
      enableHint: 'Aktivieren Sie Benachrichtigungen, um auch im Hintergrund alarmiert zu werden',
      manage: 'Verwalten', noActiveShort: 'Keine aktiven Alarme.', createOne: 'Alarm erstellen',
    },
    p2p: {
      badge: 'Neu',
      title: 'Direkthandel',
      subtitle: 'Kaufen und verkaufen Sie direkt mit anderen Nutzern. Ihre Gelder sind bis zum Abschluss sicher bei alphaswapp hinterlegt.',
      buy: 'Kaufen',
      sell: 'Verkaufen',
      orderbook: 'Orderbuch',
      myOrders: 'Meine Orders',
      createOrder: 'Order erstellen',
      amount: 'Betrag',
      price: 'Stückpreis',
      total: 'Gesamt',
      commission: 'Verkäufergebühr 7%',
      noOrders: 'Keine Orders verfügbar. Erstellen Sie Ihre!',
      takeOrder: 'Diese Order annehmen',
      waiting: 'Warten auf Gegenpartei',
      matched: 'Gegenpartei gefunden',
      escrowPending: 'Krypto wird geprüft',
      escrowReceived: 'Krypto hinterlegt',
      fiatSent: 'Zahlung gesendet',
      completed: 'Abgeschlossen',
      cancelled: 'Storniert',
      sendCrypto: 'Senden Sie die Krypto an die alphaswapp-Wallet',
      uploadReceipt: 'Bankbeleg hochladen',
      iSent: 'Ich habe die Krypto gesendet',
      bankCard: 'Bankkarte',
      bankName: 'Bank',
      walletAddr: 'Ihre Wallet-Adresse',
      network: 'Netzwerk',
      escrowInfo: 'Gelder maximal 45 Minuten blockiert',
      howTitle: 'Wie funktioniert es?',
      how1: 'Der Verkäufer sendet Krypto an die sichere alphaswapp-Wallet',
      how2: 'Der Käufer sendet die Bankzahlung direkt an den Verkäufer',
      how3: 'Nach Belegprüfung wird die Krypto an den Käufer freigegeben',
      presentTitle: 'Handeln Sie direkt, miteinander',
      presentDesc: 'Ein P2P-Orderbuch mit sicherem Treuhandservice: Ihre Orders bleiben aktiv, bis eine Gegenpartei gefunden ist.',
      cta: 'Direkthandel entdecken',
    },
    common: {
      quickCalc: 'Berechnen Sie Ihren Umtausch live',
      authSubtitle: 'Zugriff auf Ihr alphaswapp-Konto',
      dashboard: 'Dashboard',
      logout: 'Abmelden',
      level: 'Stufe',
      high: 'Hoch',
      low: 'Tief',
      variation: 'Änderung',
      price: 'Preis',
      transferSuccess: 'Ihre Überweisungsanfrage wurde gesendet!',
      invalidAmount: 'Ungültiger Betrag',
      nameRequired: 'Name erforderlich',
      phoneRequired: 'Telefon erforderlich',
      invalidEmail: 'Ungültige E-Mail',
      start: 'Starten',
      continueGoogle: 'Mit Google fortfahren',
      loading: 'Laden...',
      processing: 'Verarbeitung...',
      home: 'Startseite',
      rateLocked: 'Kurs gesperrt',
      rateLockInfo: 'Kurs für 10 Minuten garantiert',
      lockExpired: 'Kurs abgelaufen, wird aktualisiert...',
      kycRequired: 'Identitätsprüfung erforderlich',
      kycRequiredDesc: 'Vervollständigen Sie Ihr KYC, um Ihre Limits zu erhöhen',
      secure: 'Sicher',
      fast: 'Schnell',
      recentExchanges: 'Letzte Umtausche',
      sent: 'Gesendet',
      received: 'Erhalten',
      date: 'Datum',
      direction: 'Richtung',
      commission: 'Provision',
      exchangeTime: 'Umtauschzeit',
      supportAvailable: 'Support verfügbar',
      liveRates: 'Live-Preise',
    },
    nav: {
      exchange: "Tausch",
      cards: "Karten",
      business: "Business",
      privacy: "Datenschutz",
      login: "Anmelden",
      logout: "Abmelden",
      dashboard: "Dashboard",
      admin: "Admin",
      home: "Startseite",
      sendMoney: "Geld senden"
    },
    hero: {
      calcDesc: 'Kurse werden alle 30 Sekunden aktualisiert. Sperren Sie Ihren Preis für 10 Minuten bei der Transaktion.',
      rateLock: 'Kurs 10 Min. gesperrt',
      darkTitle: 'Eine einzige Gebühr. Null Überraschungen.',
      darkDesc: '7% alles inklusive bei jeder Operation — Kauf, Verkauf, Versand. Keine versteckten Gebühren.',
      commissionTitle: '7% alles inklusive',
      commissionDesc: 'Eine transparente Gebühr bei jeder Operation. Wird vor der Bestätigung angezeigt.',

      badge: "Ultraschneller Krypto-Tausch",
      title: "Tauschen Sie Ihre Kryptos mit voller",
      titleHighlight: "Sicherheit",
      description: "Die schnellste und sicherste Tauschplattform. Unterstützung für über 20 Kryptowährungen mit den besten Marktpreisen.",
      startBtn: "Jetzt starten",
      apiBtn: "Entwickler-API"
    },
    exchangeWidget: {
      title: "Schnell-Konverter",
      youSend: "Sie senden",
      youReceive: "Sie erhalten",
      youGive: "Sie geben",
      rate: "Wechselkurs",
      fees: "Gebühren",
      exchange: "Jetzt tauschen",
      buy: "Kaufen",
      sell: "Verkaufen",
      selectCrypto: "Krypto wählen",
      selectPayment: "Zahlung wählen",
      enterAmount: "Betrag eingeben",
      accountInfo: "Kontoinformationen",
      email: "E-Mail",
      continue: "Weiter",
      confirm: "Tausch bestätigen"
    },
    features: {
      title: "Warum alphaswapp wählen?",
      speed: {
        title: "Sofortiger Tausch",
        description: "Erhalten Sie Ihr Geld in wenigen Minuten mit unserem automatisierten System"
      },
      security: {
        title: "100% Sicher",
        description: "Ihre Transaktionen sind durch fortschrittliche Sicherheitsprotokolle geschützt"
      },
      support: {
        title: "24/7 Support",
        description: "Unser Team steht Ihnen jederzeit zur Verfügung"
      }
    },
    recentExchanges: {
      title: "Letzte Tauschvorgänge",
      ago: "vor"
    },
    reviews: {
      title: "Neueste Bewertungen"
    },
    services: {
      exchange: "Tausch",
      qrPayment: "QR-Zahlung",
      mobileMoney: "Prepaid-Karten",
      bankTransfer: "Überweisung",
      wallet: "Wallet",
      send: "Senden",
      cashback: "Cashback"
    },
    auth: {
      login: "Anmelden",
      register: "Registrieren",
      email: "E-Mail",
      password: "Passwort",
      phone: "Telefon",
      loginBtn: "Anmelden",
      registerBtn: "Registrieren",
      googleBtn: "Mit Google fortfahren",
      or: "oder",
      noAccount: "Noch kein Konto?",
      hasAccount: "Bereits ein Konto?",
      terms: "Mit der Anmeldung akzeptieren Sie unsere",
      termsLink: "Nutzungsbedingungen",
      privacyLink: "Datenschutzrichtlinie"
    },
    dashboard: {
      welcome: "Hallo",
      overview: "Hier ist eine Übersicht Ihres Kontos",
      totalValue: "Gesamtwert",
      totalVolume: "Gesamtvolumen",
      vipLevel: "VIP-Level",
      cashbackEarned: "Verdientes Cashback",
      readyToExchange: "Bereit zum Tauschen?",
      cashbackBenefit: "Erhalten Sie Cashback bei Ihren Tauschvorgängen",
      exchangeNow: "Jetzt tauschen",
      wallet: "Wallet",
      cashback: "Cashback",
      progression: "Fortschritt",
      earned: "Verdient",
      currentRate: "Aktueller Satz",
      exchangeHistory: "Tausch-Historie",
      verifyIdentity: "Identität verifizieren",
      notVerified: "Nicht verifiziert",
      pending: "Ausstehend",
      verified: "Verifiziert",
      rejected: "Abgelehnt"
    },
    kyc: {
      title: "Identitätsprüfung (KYC)",
      subtitle: "Verifizieren Sie Ihre Identität, um alle Funktionen freizuschalten",
      step1: "Persönliche Daten",
      step2: "Ausweisdokument",
      step3: "Verifizierungs-Selfie",
      firstName: "Vorname",
      lastName: "Nachname",
      dateOfBirth: "Geburtsdatum",
      nationality: "Staatsangehörigkeit",
      address: "Adresse",
      city: "Stadt",
      phone: "Telefon",
      idType: "Dokumenttyp",
      idNumber: "Dokumentnummer",
      passport: "Reisepass",
      idCard: "Personalausweis",
      driverLicense: "Führerschein",
      residencePermit: "Aufenthaltserlaubnis",
      frontSide: "Vorderseite",
      backSide: "Rückseite",
      selfie: "Verifizierungs-Selfie",
      uploadClick: "Klicken zum Hochladen",
      previous: "Zurück",
      next: "Weiter",
      submit: "Absenden",
      submitting: "Wird gesendet...",
      pendingTitle: "Verifizierung läuft",
      pendingDesc: "Wir prüfen Ihre Dokumente. Geschätzte Zeit: 24-48 Stunden.",
      approvedTitle: "Identität verifiziert",
      approvedDesc: "Ihr Konto ist vollständig verifiziert.",
      backToDashboard: "Zurück zum Dashboard"
    },
    payment: {
      title: "Zahlungsbestätigung",
      requestNumber: "Anfrage-Nr.",
      status: "Status",
      awaitingPayment: "Warte auf Zahlung",
      sendExactly: "Senden Sie genau",
      toAddress: "an folgende Adresse",
      copyAddress: "Adresse kopieren",
      copied: "Kopiert!",
      timeRemaining: "Verbleibende Zeit",
      youWillReceive: "Sie erhalten",
      hasPaid: "Ich habe bezahlt",
      cancel: "Abbrechen"
    },
    footer: {
      description: "Die schnellste und sicherste Krypto-Tauschplattform.",
      navigation: "Navigation",
      legal: "Rechtliches",
      privacy: "Datenschutz",
      cookies: "Cookies",
      terms: "AGB",
      contact: "Kontakt",
      copyright: "Alle Rechte vorbehalten.",
      cryptoExchange: "Krypto-Tausch",
      buySell: "Kaufen/Verkaufen",
      converter: "Konverter",
      paymentMethods: "Zahlungsmethoden",
      bankTransfer: "Banküberweisung",
      prepaidCards: "Prepaid-Karten",
      paymentAcceptance: "Zahlungen akzeptieren",
      businessAccount: "Business-Konto",
      merchantTools: "Händler-Tools",
      company: "Unternehmen",
      aboutUs: "Über uns",
      helpCenter: "Hilfezentrum",
      blog: "Blog",
      careers: "Karriere",
      resources: "Ressourcen",
      fees: "Gebühren",
      referral: "Empfehlung",
      security: "Sicherheit",
      followUs: "Folge uns",
      downloadApp: "App herunterladen",
      downloadOn: "Laden im",
      getItOn: "Jetzt bei",
      recommendedBy: "Empfohlen von"
    },
    stats: {
      activeUsers: "Aktive Nutzer",
      volumeExchanged: "Getauschtes Volumen",
      cryptos: "Kryptowährungen",
      avgTime: "Durchschnittszeit"
    },
    faq: {
      title: "Häufig gestellte Fragen",
      subtitle: "Alles, was Sie wissen müssen",
      q1: "Wie führe ich einen Tausch auf unserem Service durch?",
      a1: "Wählen Sie die zu tauschende Kryptowährung, geben Sie den Betrag ein, wählen Sie Ihre Zahlungsmethode und bestätigen Sie.",
      q2: "Wie lange dauert der Tausch?",
      a2: "Die meisten Tausche werden in 5 bis 15 Minuten verarbeitet.",
      q3: "Wie hoch sind Ihre Transaktionsgebühren?",
      a3: "Eine einzige All-inclusive-Gebühr von 7% gilt für jede Operation (Kauf, Verkauf, Versand). Keine versteckten Gebühren: Der genaue Betrag wird vor der Bestätigung angezeigt.",
      q4: "Welche Zahlungsmethoden akzeptieren Sie?",
      a4: "Wir akzeptieren: SEPA-Überweisungen, Revolut, Visa, Mastercard, Cashlib, Transcash, Neosurf, PCS Mastercard.",
      q5: "Sind meine Daten sicher?",
      a5: "Absolut! Wir verwenden bankentaugliche Verschlüsselung zum Schutz Ihrer Daten.",
      q6: "Wie funktioniert das Empfehlungsprogramm?",
      a6: "Teilen Sie Ihren einzigartigen Link mit Freunden. Sie erhalten 10% Provision auf deren Transaktionsgebühren, lebenslang!"
    },
    reviews: { title: "Neueste Bewertungen", r1: "Schneller und zuverlässiger Service.", r2: "Exzellenter Wechselkurs.", r3: "Intuitive Oberfläche.", r4: "Beste Tauschplattform.", r5: "Sehr wettbewerbsfähige Gebühren.", r6: "SEPA-Überweisung funktioniert perfekt." },
    admin: { title: "Admin-Panel", subtitle: "Tausch-Anfragenverwaltung", refresh: "Aktualisieren", users: "Benutzer", pendingRequests: "Ausstehend", completedRequests: "Abgeschlossen", totalVolume: "Gesamtvolumen", exchangeRequests: "Tauschanfragen", usersTab: "Benutzer", allStatuses: "Alle Status", noRequests: "Keine Anfragen gefunden", requestNumber: "Anfrage-Nr.", email: "Email", gives: "Gibt", receives: "Erhält", status: "Status", date: "Datum", actions: "Aktionen", name: "Name", role: "Rolle", level: "Stufe", volume: "Volumen", cashback: "Cashback", registeredOn: "Registriert am", pending: "Ausstehend", confirming: "Bestätigung", processing: "Verarbeitung", completed: "Abgeschlossen", cancelled: "Storniert", rejected: "Abgelehnt" }
  },

  ru: {
    p2pExtra: {
      channelClosed: 'Прямая торговля временно закрыта', operatorInfo: 'Информация оператора',
      companyCounterparty: 'Контрагент: alphaswapp — вы Тейкер', p2pCounterparty: 'P2P — обмен между клиентами',
      delayWarning: 'Обработка может занять до 24 дополнительных часов в случае усиленной проверки, контроля целостности платежа или непредвиденных обстоятельств. Спасибо за терпение.',
      sendCryptoAdmin: 'Отправьте криптовалюту на адрес, указанный оператором:',
      payToCardAdmin: 'Отправьте платёж на карту, указанную оператором, затем загрузите квитанцию:',
      waitingCardInfo: 'Оператор сообщит вам платёжные реквизиты здесь. Вы также можете связаться с ним через чат поддержки.',
      waitingEscrow: 'Ожидание крипто-депозита продавца...',
      grossAmount: 'Сумма брутто', commission7: 'Комиссия 7%', youReceive: 'Вы получите',
      buyerWillGet: 'Передано покупателю', buyerGets: 'Покупатель получает', chooseBank: 'Ваш банк',
      cancelBtn: 'Отмена',
      autoPrice: 'Цена за единицу — рыночный курс (автоматически)', liveRate: 'В реальном времени',
      sellerEscrowPending: 'Криптовалюта отправлена — оператор проверяет получение депозита.',
      sellerEscrowReceived: 'Депозит подтверждён ✓ — ожидание платежа покупателя.',
      sellerFiatSent: 'Покупатель заявил об оплате — оператор проверяет квитанцию перед завершением.',
    },
    support: {
      title: 'Поддержка alphaswapp', online: 'Онлайн — быстрый ответ',
      empty: 'Вопрос о вашей транзакции? Напишите нам, наша команда ответит здесь.',
      placeholder: 'Ваше сообщение...', tooBig: 'Файл слишком большой (макс. 10 МБ)',
      telegram: 'Или напишите нам в Telegram: @alphaswapp',
    },
    fiatlive: { title: 'Курсы валют в реальном времени' },
    alerts: {
      navLabel: 'Оповещения', badge: 'Реальное время', title: 'Ценовые оповещения',
      subtitle: 'Получайте уведомление, как только цена достигнет вашего порога, даже если вкладка закрыта.',
      enableNotifs: 'Включить уведомления', disableNotifs: 'Отключить уведомления',
      notifsEnabled: 'Уведомления включены!', notifsDisabled: 'Уведомления отключены',
      notifsBlocked: 'Уведомления заблокированы браузером. Разрешите их в настройках сайта.',
      notSupported: 'Браузер не поддерживается', createTitle: 'Новое оповещение', crypto: 'Криптовалюта',
      condition: 'Условие', above: 'Выше', below: 'Ниже', targetPrice: 'Целевая цена',
      currentPrice: 'Текущая цена', create: 'Создать оповещение', creating: 'Создание...',
      created: 'Оповещение создано!', deleted: 'Оповещение удалено', invalidPrice: 'Неверная целевая цена',
      error: 'Произошла ошибка', activeTitle: 'Активные оповещения',
      noActive: 'Нет активных оповещений. Создайте одно, чтобы получать уведомления.',
      triggeredTitle: 'Сработавшие оповещения', triggeredAt: 'Сработало при',
      enableHint: 'Включите уведомления, чтобы получать оповещения даже в фоновом режиме',
      manage: 'Управлять', noActiveShort: 'Нет активных оповещений.', createOne: 'Создать оповещение',
    },
    p2p: {
      badge: 'Новинка',
      title: 'Прямой трейдинг',
      subtitle: 'Покупайте и продавайте напрямую с другими пользователями. Ваши средства защищены эскроу alphaswapp до завершения сделки.',
      buy: 'Купить',
      sell: 'Продать',
      orderbook: 'Книга ордеров',
      myOrders: 'Мои ордера',
      createOrder: 'Создать ордер',
      amount: 'Сумма',
      price: 'Цена за единицу',
      total: 'Итого',
      commission: 'Комиссия продавца 7%',
      noOrders: 'Нет доступных ордеров. Создайте свой!',
      takeOrder: 'Принять этот ордер',
      waiting: 'Ожидание контрагента',
      matched: 'Контрагент найден',
      escrowPending: 'Криптовалюта проверяется',
      escrowReceived: 'Криптовалюта в эскроу',
      fiatSent: 'Платёж отправлен',
      completed: 'Завершено',
      cancelled: 'Отменено',
      sendCrypto: 'Отправьте криптовалюту на кошелёк alphaswapp',
      uploadReceipt: 'Загрузить банковский чек',
      iSent: 'Я отправил криптовалюту',
      bankCard: 'Банковская карта',
      bankName: 'Банк',
      walletAddr: 'Адрес вашего кошелька',
      network: 'Сеть',
      escrowInfo: 'Средства блокируются максимум на 45 минут',
      howTitle: 'Как это работает?',
      how1: 'Продавец отправляет криптовалюту на защищённый кошелёк alphaswapp',
      how2: 'Покупатель отправляет банковский платёж напрямую продавцу',
      how3: 'После проверки чека криптовалюта передаётся покупателю',
      presentTitle: 'Торгуйте напрямую, между собой',
      presentDesc: 'P2P книга ордеров с безопасным эскроу: ваши ордера остаются активными до нахождения контрагента.',
      cta: 'Открыть Прямой трейдинг',
    },
    common: {
      quickCalc: 'Рассчитайте обмен в реальном времени',
      authSubtitle: 'Войдите в свой аккаунт alphaswapp',
      dashboard: 'Личный кабинет',
      logout: 'Выйти',
      level: 'Уровень',
      high: 'Максимум',
      low: 'Минимум',
      variation: 'Изменение',
      price: 'Цена',
      transferSuccess: 'Ваш запрос на перевод отправлен!',
      invalidAmount: 'Неверная сумма',
      nameRequired: 'Укажите имя',
      phoneRequired: 'Укажите телефон',
      invalidEmail: 'Неверный email',
      start: 'Начать',
      continueGoogle: 'Продолжить с Google',
      loading: 'Загрузка...',
      processing: 'Обработка...',
      home: 'Главная',
      rateLocked: 'Курс зафиксирован',
      rateLockInfo: 'Курс гарантирован в течение 10 минут',
      lockExpired: 'Курс истёк, обновление...',
      kycRequired: 'Требуется проверка личности',
      kycRequiredDesc: 'Пройдите KYC, чтобы увеличить лимиты обмена',
      secure: 'Безопасно',
      fast: 'Быстро',
      recentExchanges: 'Последние обмены',
      sent: 'Отправлено',
      received: 'Получено',
      date: 'Дата',
      direction: 'Направление',
      commission: 'Комиссия',
      exchangeTime: 'Время обмена',
      supportAvailable: 'Поддержка доступна',
      liveRates: 'Цены в реальном времени',
    },
    nav: {
      exchange: "Обмен",
      cards: "Карты",
      business: "Бизнес",
      privacy: "Конфиденциальность",
      login: "Войти",
      logout: "Выйти",
      dashboard: "Панель",
      admin: "Админ",
      home: "Главная",
      sendMoney: "Денежный перевод"
    },
    hero: {
      calcDesc: 'Курсы обновляются каждые 30 секунд. Зафиксируйте цену на 10 минут в момент транзакции.',
      rateLock: 'Курс зафиксирован на 10 мин',
      darkTitle: 'Одна комиссия. Ноль сюрпризов.',
      darkDesc: '7% всё включено на каждую операцию — покупка, продажа, перевод. Без скрытых комиссий.',
      commissionTitle: '7% всё включено',
      commissionDesc: 'Одна прозрачная комиссия на каждую операцию. Отображается до подтверждения.',

      badge: "Сверхбыстрый криптообмен",
      title: "Обменивайте криптовалюту с полной",
      titleHighlight: "безопасностью",
      description: "Самая быстрая и безопасная платформа обмена. Поддержка более 20 криптовалют с лучшими рыночными курсами.",
      startBtn: "Начать сейчас",
      apiBtn: "API для разработчиков"
    },
    exchangeWidget: {
      title: "Быстрый конвертер",
      youSend: "Вы отправляете",
      youReceive: "Вы получаете",
      youGive: "Вы даете",
      rate: "Курс обмена",
      fees: "Комиссия",
      exchange: "Обменять сейчас",
      buy: "Купить",
      sell: "Продать",
      selectCrypto: "Выбрать крипто",
      selectPayment: "Выбрать оплату",
      enterAmount: "Введите сумму",
      accountInfo: "Данные аккаунта",
      email: "Email",
      continue: "Продолжить",
      confirm: "Подтвердить обмен"
    },
    features: {
      title: "Почему выбирают alphaswapp?",
      speed: {
        title: "Мгновенный обмен",
        description: "Получите средства за минуты благодаря нашей автоматизированной системе"
      },
      security: {
        title: "100% Безопасность",
        description: "Ваши транзакции защищены передовыми протоколами безопасности"
      },
      support: {
        title: "Поддержка 24/7",
        description: "Наша команда всегда готова помочь вам"
      }
    },
    recentExchanges: {
      title: "Последние обмены",
      ago: "назад"
    },
    reviews: {
      title: "Последние отзывы"
    },
    services: {
      exchange: "Обмен",
      qrPayment: "QR-оплата",
      mobileMoney: "Предоплаченные карты",
      bankTransfer: "Перевод",
      cards: "Карты",
      wallet: "Кошелек",
      send: "Отправить",
      cashback: "Кэшбэк"
    },
    auth: {
      login: "Вход",
      register: "Регистрация",
      email: "Email",
      password: "Пароль",
      phone: "Телефон",
      loginBtn: "Войти",
      registerBtn: "Зарегистрироваться",
      googleBtn: "Продолжить с Google",
      or: "или",
      noAccount: "Нет аккаунта?",
      hasAccount: "Уже есть аккаунт?",
      terms: "Входя, вы соглашаетесь с нашими",
      termsLink: "Условиями использования",
      privacyLink: "Политикой конфиденциальности"
    },
    dashboard: {
      welcome: "Привет",
      overview: "Обзор вашего аккаунта",
      totalValue: "Общая стоимость",
      totalVolume: "Общий объем",
      vipLevel: "VIP уровень",
      cashbackEarned: "Заработанный кэшбэк",
      readyToExchange: "Готовы к обмену?",
      cashbackBenefit: "Получайте кэшбэк за обмены",
      exchangeNow: "Обменять сейчас",
      wallet: "Кошелек",
      cashback: "Кэшбэк",
      progression: "Прогресс",
      earned: "Заработано",
      currentRate: "Текущая ставка",
      exchangeHistory: "История обменов",
      verifyIdentity: "Подтвердить личность",
      notVerified: "Не подтверждено",
      pending: "На проверке",
      verified: "Подтверждено",
      rejected: "Отклонено"
    },
    kyc: {
      title: "Верификация личности (KYC)",
      subtitle: "Подтвердите личность для доступа ко всем функциям",
      step1: "Личные данные",
      step2: "Документ",
      step3: "Селфи для проверки",
      firstName: "Имя",
      lastName: "Фамилия",
      dateOfBirth: "Дата рождения",
      nationality: "Гражданство",
      address: "Адрес",
      city: "Город",
      phone: "Телефон",
      idType: "Тип документа",
      idNumber: "Номер документа",
      passport: "Паспорт",
      idCard: "Удостоверение личности",
      driverLicense: "Водительские права",
      residencePermit: "Вид на жительство",
      frontSide: "Лицевая сторона",
      backSide: "Обратная сторона",
      selfie: "Селфи для проверки",
      uploadClick: "Нажмите для загрузки",
      previous: "Назад",
      next: "Далее",
      submit: "Отправить",
      submitting: "Отправка...",
      pendingTitle: "Проверка в процессе",
      pendingDesc: "Мы проверяем ваши документы. Ожидаемое время: 24-48 часов.",
      approvedTitle: "Личность подтверждена",
      approvedDesc: "Ваш аккаунт полностью верифицирован.",
      backToDashboard: "Вернуться в панель"
    },
    payment: {
      title: "Подтверждение оплаты",
      requestNumber: "№ заявки",
      status: "Статус",
      awaitingPayment: "Ожидание оплаты",
      sendExactly: "Отправьте точно",
      toAddress: "на следующий адрес",
      copyAddress: "Копировать адрес",
      copied: "Скопировано!",
      timeRemaining: "Осталось времени",
      youWillReceive: "Вы получите",
      hasPaid: "Я оплатил",
      cancel: "Отмена"
    },
    footer: {
      description: "Самая быстрая и безопасная платформа криптообмена.",
      navigation: "Навигация",
      legal: "Правовая информация",
      privacy: "Конфиденциальность",
      cookies: "Cookies",
      terms: "Условия",
      contact: "Контакты",
      copyright: "Все права защищены.",
      cryptoExchange: "Криптообмен",
      buySell: "Купить/Продать",
      converter: "Конвертер",
      paymentMethods: "Способы оплаты",
      bankTransfer: "Банковский перевод",
      prepaidCards: "Предоплаченные карты",
      paymentAcceptance: "Прием платежей",
      businessAccount: "Бизнес-аккаунт",
      merchantTools: "Инструменты продавца",
      company: "Компания",
      aboutUs: "О нас",
      helpCenter: "Центр помощи",
      blog: "Блог",
      careers: "Карьера",
      resources: "Ресурсы",
      fees: "Комиссии",
      referral: "Рефералы",
      security: "Безопасность",
      followUs: "Подписывайтесь",
      downloadApp: "Скачать приложение",
      downloadOn: "Загрузить в",
      getItOn: "Доступно в",
      recommendedBy: "Рекомендовано"
    },
    stats: {
      activeUsers: "Активных пользователей",
      volumeExchanged: "Объем обменов",
      cryptos: "Криптовалют",
      avgTime: "Среднее время"
    },
    faq: {
      title: "Часто задаваемые вопросы",
      subtitle: "Всё, что вам нужно знать",
      q1: "Как совершить обмен на нашем сервисе?",
      a1: "Выберите криптовалюту для обмена, введите сумму, выберите способ оплаты и подтвердите. Вы получите средства через несколько минут после проверки.",
      q2: "Сколько времени занимает обмен?",
      a2: "Большинство обменов обрабатываются за 5-15 минут. Банковские переводы могут занять 1-2 рабочих дня.",
      q3: "Каковы ваши комиссии за транзакции?",
      a3: "Единая комиссия 7% (всё включено) применяется к каждой операции (покупка, продажа, перевод). Без скрытых комиссий: точная сумма отображается до подтверждения.",
      q4: "Какие способы оплаты вы принимаете?",
      a4: "Мы принимаем: SEPA-переводы, Revolut, Visa, Mastercard, Cashlib, Transcash, Neosurf, PCS Mastercard.",
      q5: "Мои данные в безопасности?",
      a5: "Безусловно! Мы используем банковский уровень шифрования для защиты ваших данных.",
      q6: "Как работает реферальная программа?",
      a6: "Поделитесь уникальной ссылкой с друзьями. Вы получаете 10% комиссии от их транзакционных сборов навсегда!"
    },
    reviews: {
      title: "Последние отзывы",
      r1: "Быстрый и надёжный сервис! Транзакция менее чем за 5 минут.",
      r2: "Отличный обменный курс. Очень рекомендую эту платформу.",
      r3: "Интуитивный интерфейс и быстрая поддержка клиентов. Идеально!",
      r4: "Лучшая платформа обмена, которую я использовал. Очень профессионально.",
      r5: "Очень конкурентоспособные комиссии и сверхбыстрые транзакции.",
      r6: "SEPA-перевод работает отлично. Превосходная платформа!"
    },
    admin: {
      title: "Панель администратора",
      subtitle: "Управление заявками на обмен",
      refresh: "Обновить",
      users: "Пользователи",
      pendingRequests: "Ожидающие",
      completedRequests: "Завершённые",
      totalVolume: "Общий объём",
      exchangeRequests: "Заявки на обмен",
      usersTab: "Пользователи",
      allStatuses: "Все статусы",
      noRequests: "Заявки не найдены",
      requestNumber: "№ Заявки",
      email: "Email",
      gives: "Отдаёт",
      receives: "Получает",
      status: "Статус",
      date: "Дата",
      actions: "Действия",
      name: "Имя",
      role: "Роль",
      level: "Уровень",
      volume: "Объём",
      cashback: "Кэшбэк",
      registeredOn: "Зарегистрирован",
      pending: "Ожидание",
      confirming: "Подтверждение",
      processing: "Обработка",
      completed: "Завершено",
      cancelled: "Отменено",
      rejected: "Отклонено"
    },
    sendMoney: {
      badge: "Международные переводы",
      title: "Отправляйте деньги просто",
      subtitle: "Переводите деньги в Европу, Азию и Россию. Быстро, безопасно и прозрачно.",
      promoTitle: "Отправляйте деньги за рубеж",
      promoDesc: "Просто как банковский перевод. Отправляйте деньги без забот о криптовалютах.",
      cta: "Отправить сейчас",
      step1: "Сколько отправляете?",
      step2: "Получатель",
      step3: "Подтверждение",
      youSend: "Вы отправляете",
      destination: "Направление",
      theyReceive: "Получатель получит",
      commission: "Комиссия",
      rate: "Обменный курс",
      continue: "Продолжить",
      back: "Назад",
      recipientName: "Полное имя получателя",
      recipientPhone: "Телефон получателя",
      yourEmail: "Ваш email",
      confirmSend: "Подтвердить отправку",
      success: "Перевод инициирован!",
      successDesc: "Ваш запрос на перевод отправлен. Вы получите email с инструкциями.",
      backHome: "Вернуться на главную",
      destinations: "Популярные направления",
      secure: "Безопасный перевод",
      fast: "24-48ч",
      users: "пользователей"
    }
  }
};
